import * as React from 'react';

import { MapSheet, MapSheetProps } from 'components/common/map/sheets/map-sheet';

export const MapSheetWrapper: React.FunctionComponent<MapSheetProps> = ({
  splitView,
  sheet,
  selectedHotel,
  onClick,
  onFavoriteClick,
  isVisible,
  l10n
}) => {
  const mapSheetProps = { splitView, sheet, selectedHotel, onClick, onFavoriteClick, isVisible, l10n };

  if (!splitView) {
    return <MapSheet {...mapSheetProps} />;
  } else {
    return (
      <div className="split-view__sheet-container">
        <MapSheet {...mapSheetProps} />
      </div>
    );
  }
};
